interface HeaderAttr {
  background: string;
  fixedTop: boolean;
  higher: boolean;
  hideNav: boolean;
  hideAll?: boolean;
}

const header = {
  namespaced: true,
  state: {
    background: "transparent",
    fixedTop: true,
    higher: true,
    hideNav: false,
    hideAll: false
  } as HeaderAttr,
  mutations: {
    setBackground(state: HeaderAttr, background: string) {
      state.background = background;
    },
    setFixedTop(state: HeaderAttr, fixedTop: boolean) {
      state.fixedTop = fixedTop;
    },
    setHigher(state: HeaderAttr, higher: boolean) {
      state.higher = higher;
    },
    setHideNav(state: HeaderAttr, hideNav: boolean) {
      state.hideNav = hideNav;
    },
    setHeaderAttr(state: HeaderAttr, options: HeaderAttr) {
      state.fixedTop = options.fixedTop;
      state.background = options.background;
      state.higher = options.higher;
      state.hideNav = options.hideNav;
      state.hideAll = options.hideAll;
    }
  }
};

export default header;
